import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Box } from 'signoxe/components/layout';
import { Button, Popup, Icon, Switch } from 'signoxe/components/widgets';
import './styles.scss';

import {toggleDeviceId, updateDeviceGroup, updateContentFeed, fetchDeviceGroups, confirmationRequest, fetchAssets} from "signoxe/actions";
import {CONTENT_FEEDS_RESOURCE, DEVICE_GROUPS_RESOURCE, DEVICES_RESOURCE} from "signoxe/api/resources";
import { API_ROOT } from 'signoxe/constants/config';
import {getAuthTokenHeader} from "signoxe/actions/remote";
import { Link } from 'react-router-dom/es';


import { getDeviceGroup, getProfile } from 'signoxe/selectors';

import { callOnEnter } from 'signoxe/utils/eventHelpers';

import {
  ContentFeedView,
} from 'signoxe/components';

import { OrientationSelectWidget} from "signoxe/components/widgets/OrientationSelectWidget";

import URLAssetEditPage from './components/Url';
import AQIAirvedaPage from './components/Aqi_Airveda'
import FidsAssetPage from './components/Fids';
import AQIAssetPage from './components/Aqi';
import CalendarAssetPage from './components/Calendar';
import HtmlPage from './components/Html';
import ScrollerAppPage from './components/Scroller'


class AssetModal extends React.Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired
  };

  constructor(props){
    super(props);

    this.state = {
      addMode: false,
      currentKey: null
    }

    this.components = {
      'fids': FidsAssetPage,
      'aqi': AQIAssetPage,
      'aqi_airveda': AQIAirvedaPage,
      'youtube': 'Youtube component',
      'twitter': 'Twitter Feeds',
      'calendar': CalendarAssetPage,
      'url': URLAssetEditPage,
      'html': HtmlPage,
      'scroller':ScrollerAppPage,
    }
  }

  switchComponent(key){
    this.setState({currentKey: key})
  }

  close(){
    const { disable } = this.props;

    disable();
    this.setState({currentKey: null, addMode: false})
  }

  renderComponent(currentKey){
    const Component = this.components[currentKey];
    if(typeof(Component) === 'string'){
      return <div>Asset not yet supported.</div>
    }
    return <Component refresh={this.props.fetchAssets} history={this.props.history} disable={this.close.bind(this)} />
  }

  render() {
    const { visible, disable } = this.props;

    const { currentKey } = this.state

    if (visible){
      return (
        <Popup className="asset-content-popup"
               modal>
          <Box className='modal-wrapper' direction="column" justifyContent="center">
            {
              this.state.addMode ?
              <Box className='asset-wrapper'>
                Component which would only be triggered if a new component is being added
              </Box> :
              <Box className='asset-wrapper' direction="row">
                <Icon className='close-icon' size="1.5rem" onClick={()=>this.close()} name="close" margin={0} color="#000"/>
                <div className='component-dropdown'>
                  <ul className='component-list'>
                    <li className={currentKey == 'fids' ? 'active': ''} onClick={()=>this.switchComponent('fids')}>
                      <Icon name="table" margin={0} color="#000"/>
                      FIDS
                    </li>
                    <li className={currentKey == 'aqi' ? 'active': ''} onClick={()=>this.switchComponent('aqi')}>
                      <Icon name="window-maximize" margin={0} color="#000"/>
                      AQI
                    </li>
                    <li className={currentKey == 'aqi_airveda' ? 'active': ''} onClick={()=>this.switchComponent('aqi_airveda')}>
                      <Icon name="table" margin={0} color="#000"/>
                      AQI_Airveda
                    </li>
                    <li className={currentKey == 'youtube' ? 'active': ''} onClick={()=>this.switchComponent('youtube')}>
                      <Icon name="calendar" margin={0} color="#000"/>
                      Youtube
                    </li>
                    <li className={currentKey == 'twitter' ? 'active': ''} onClick={()=>this.switchComponent('twitter')}>
                      <Icon name="window-maximize" margin={0} color="#000"/>
                      Twitter Feeds
                    </li>
                    <li className={currentKey == 'calendar' ? 'active': ''} onClick={()=>this.switchComponent('calendar')}>
                      <Icon name="calendar" margin={0} color="#000"/>
                      Calendar
                    </li>
                    <li className={currentKey == 'url' ? 'active': ''} onClick={()=>this.switchComponent('url')}>
                      <Icon name="window-maximize" margin={0} color="#000"/>
                      URL
                    </li>
                    <li onClick={()=>this.props.history.push('/assets/new/data')}>
                      <Icon name="code" margin={0} color="#000"/>
                      Data Asset
                    </li>
                    <li className={currentKey == 'html' ? 'active': ''} onClick={()=>this.switchComponent('html')}>
                      <Icon name="code" margin={0} color="#000"/>
                      HTML Asset
                    </li>
                  </ul>
                </div>
                <div className='sub-component-list'>
                  {
                    currentKey ?
                    this.renderComponent(currentKey)
                    : 'Begin by adding an application now.'
                  }
                </div>
              </Box>
            }
          </Box>
        </Popup>
      );
    }

    return null
  }
}

const mapStateToProps = (state) => {
  return {
    // state,
    // profile: getProfile(state),
  }
}

export default connect(
  mapStateToProps,
  {
    fetchAssets
    // toggleDeviceId,
    // updateDeviceGroup,
    // updateContentFeed,
    // fetchDeviceGroups,
    // confirmationRequest
  })(AssetModal);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetModal/index.js